import PropTypes from "prop-types";
import {
  Box,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  TableSortLabel,
  TablePagination,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Switch,
  Button,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import APIAxios from "../../Api/APIAxios";
import SessaoAuth from "../../Hooks/SessaoAuth";

const URL_SERVICE = "/computador";

const ComputadoresTabela = ({
  registros,
  setRegistros,
  setAvisoErro,
  setAvisoSucesso,
  setLoading,
  handleListar,
}) => {
  const { sessao, setSessao } = SessaoAuth();
  const setRowsPerPage = (newRowsPerPage) => {
    setSessao((prev) => ({ ...prev, rowsPerPage: newRowsPerPage }));
  };

  const apiAxios = APIAxios();

  const [orderBy, setOrderBy] = useState("id");
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [openExcluir, setOpenExcluir] = useState(false);
  const [selRegistro, setSelRegistro] = useState(null);
  const [updating, setUpdating] = useState(false);
  const navigate = useNavigate();

  const updateReg = async () => {
    try {
      setAvisoErro("");
      setUpdating(true);
      const registrosSemColaborador = registros.map(({ colaborador, ...rest }) => rest);

      const response = await apiAxios.put("/computadores", registrosSemColaborador)
      handleListar();
    } catch (error) {
      setAvisoErro(error.message);
    } finally {
      setUpdating(false);
      setAvisoSucesso("Atualizado com Sucesso!");
    }
  };

  // Função para ordenar os dados
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...registros].sort((a, b) => {
    if (!orderBy) return 0;

    let valueA;
    let valueB;

    switch (orderBy) {
      case "id":
        valueA = a.pk?.id ?? "";
        valueB = b.pk?.id ?? "";
        break;

      default:
        valueA = a[orderBy] ?? "";
        valueB = b[orderBy] ?? "";
        break;
    }

    if (typeof valueA === "string") {
      return order === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    } else {
      return order === "asc" ? valueA - valueB : valueB - valueA;
    }
  });

  const paginatedData = sortedData.slice(
    page * (sessao.rowsPerPage || 10),
    page * (sessao.rowsPerPage || 10) + (sessao.rowsPerPage || 10)
  );

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditar = (e, reg) => {
    e.preventDefault();
    navigate(`/computador/${reg.pk.id}`);
  };

  const handleClickOpenExcluir = (e, reg) => {
    setSelRegistro(reg);
    setOpenExcluir(true);
  };

  const handleClickCloseExcluir = () => {
    setOpenExcluir(false);
  };

  const excluirRegistro = async () => {
    setLoading(true);
    setOpenExcluir(false);
    setAvisoErro("");
    setAvisoSucesso("");

    try {
      const response = await apiAxios.delete(
        `${URL_SERVICE}/${selRegistro.pk.id}`
      );

      if (response.data.sucesso === "SIM") {
        setRegistros((prev) =>
          prev.filter((reg) => reg.pk.id !== selRegistro.pk.id)
        );
        setAvisoSucesso("Registro excluído com sucesso!");
      } else {
        setAvisoErro("Erro ao tentar excluir registro");
      }
    } catch (error) {
      setAvisoErro("Erro ao tentar excluir registro");
    }
    setLoading(false);
  };

  const handleSet = (event, item, computer) => {
    const updatedComputers = registros.map((comp) => {
      if (comp.pk.id === computer.pk.id) {
        const updatedComputer = { ...comp }; // Cria uma cópia do computador atual
        if (item === "mouse") {
          updatedComputer.regMouse =
            updatedComputer.regMouse === "S" ? "N" : "S";
        }
        if (item === "programa") {
          updatedComputer.regPrograma =
            updatedComputer.regPrograma === "S" ? "N" : "S";
        }
        if (item === "imagem") {
          updatedComputer.regImagem =
            updatedComputer.regImagem === "S" ? "N" : "S";
        }
        if (item === "token") {
          updatedComputer.token =
            updatedComputer.token.length === 0 ? "123456" : "";
        }
        if (item === "teclado") {
          updatedComputer.regTeclado =
            updatedComputer.regTeclado === "S" ? "N" : "S";
        }
        if (item === "alertas") {
          updatedComputer.recebeAlertas =
            updatedComputer.recebeAlertas === "S" ? "N" : "S";
        }
        if (item === "internet") {
          updatedComputer.regInternet =
            updatedComputer.regInternet === "S" ? "N" : "S";
        }

        return updatedComputer; // Retorna o computador atualizado
      }
      return comp; // Retorna os computadores que não foram alterados
    });

    setRegistros(updatedComputers); // Atualiza o estado com o novo array
  };

  useEffect(() => {
    setPage(0);
  }, [registros]);

  return (
    <Box>
      <Dialog
        open={openExcluir}
        onClose={handleClickCloseExcluir}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deseja EXCLUIR este registro?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <strong>ATENÇÃO!!! MUITO IMPORTANTE!</strong>
            <br />
            Se confirmar a exclusão, todos os dados referentes a este computador
            serão eliminados e <u>NÃO SERÁ POSSÍVEL RECUPERÁ-LOS.</u>.
            <br />
            <br />
            Confirma a exclusão do computador{" "}
            <strong>{selRegistro && selRegistro.pk.id}</strong> -{" "}
            <strong>{selRegistro && selRegistro.descricao}</strong> ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickCloseExcluir}>Cancelar</Button>
          <Button onClick={excluirRegistro} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Paper sx={{ mt: 2 }} elevation={4}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <TableSortLabel
                    active={orderBy === "id"}
                    direction={orderBy === "id" ? order : "asc"}
                    onClick={() => handleSort("id")}
                  >
                    Computador
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "descricao"}
                    direction={orderBy === "descricao" ? order : "asc"}
                    onClick={() => handleSort("descricao")}
                  >
                    Descrição
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center">Colaboradores</TableCell>
                <TableCell align="center">Mouse</TableCell>
                <TableCell align="center">Teclado</TableCell>
                <TableCell align="center">Programa</TableCell>
                <TableCell align="center">Imagens</TableCell>
                <TableCell align="center">Alertas</TableCell>
                <TableCell align="center">Ativo</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((computer) => (
                <TableRow key={computer.pk.id}>
                  <TableCell align="center">{computer.pk.id}</TableCell>
                  <TableCell>{computer.descricao}</TableCell>
                  <TableCell align="center">{computer.colaborador?.nome ?? "Não encontrado"}</TableCell>{/*COLABORADORES*/}
                  <TableCell align="center">
                    <Switch
                      checked={computer.regMouse === "S"}
                      color="warning"
                      size="small"
                      onClick={(event) => handleSet(event, "mouse", computer)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={computer.regTeclado === "S"}
                      color="warning"
                      size="small"
                      onClick={(event) => handleSet(event, "teclado", computer)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={computer.regPrograma === "S"}
                      color="warning"
                      size="small"
                      onClick={(event) =>
                        handleSet(event, "programa", computer)
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={computer.regImagem === "S"}
                      color="warning"
                      size="small"
                      onClick={(event) => handleSet(event, "imagem", computer)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={computer.recebeAlertas === "S"}
                      color="warning"
                      size="small"
                      onClick={(event) => handleSet(event, "alertas", computer)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={computer.token.length != 0}
                      color="warning"
                      size="small"
                      onClick={(event) => handleSet(event, "token", computer)}
                    />
                  </TableCell>

                  <TableCell>
                    <Box
                      sx={{ display: "flex", gap: 1, justifyContent: "end" }}
                    >
                      <IconButton
                        aria-label="editar"
                        onClick={(event) => handleEditar(event, computer)}
                      >
                        <EditIcon style={{ color: "#1a3865" }} />
                      </IconButton>
                      <IconButton
                        aria-label="deletar"
                        onClick={(event) =>
                          handleClickOpenExcluir(event, computer)
                        }
                      >
                        <DeleteIcon style={{ color: "#f4793c" }} />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={registros.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={sessao.rowsPerPage || 10}
          labelRowsPerPage="Linhas por página"
          rowsPerPageOptions={[5, 10, 25]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            display: "flex",
            justifyContent: "flex-end", // ou "center", se preferir

            "& .MuiTablePagination-toolbar": {
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between", // ajusta a linha interna
            },
            "& p": {
              marginBottom: 0,
            },
          }}
        />
      </Paper>
      <Box width={"100%"} display="flex" justifyContent="flex-end" mt={2}>
        <Button
          sx={{
            mt: 3,
            mb: 2,
            ml: 2,
            position: "relative",
            borderColor: "#1a3865",
            backgroundColor: "#1a3865",
          }}
          variant="contained"
          color="primary"
          onClick={() => updateReg()}
        >
          Salvar
          {updating && (
            <CircularProgress
              size={35}
              sx={{
                color: "#dcdcdc",
                position: "absolute",
                top: "0",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
              }}
            />
          )}
        </Button>
      </Box>
    </Box>
  );
};

ComputadoresTabela.propTypes = {
  registros: PropTypes.array.isRequired,
  setRegistros: PropTypes.func.isRequired,
  setAvisoErro: PropTypes.func,
  setAvisoSucesso: PropTypes.func,
  setLoading: PropTypes.func,
  handleListar: PropTypes.func,
};

export default ComputadoresTabela;
